import { Box, Typography } from '@mui/material'
import { Search } from '@workwave-tidal/core/icons/illustrations'

import { useTexts } from '../hooks/useTexts'

import { CardContainer } from './CardContainer'

type SetQueryCardProps = {
  queryMinLength: number
}

export function SetQueryCard({ queryMinLength }: SetQueryCardProps) {
  const texts = useTexts()

  return (
    <CardContainer>
      <Box pb={1}>
        <Search size={48} />
      </Box>

      <Typography variant="subtitle4">{texts.card.setQuery.title}</Typography>
      <Typography variant="caption">{texts.card.setQuery.subtitle(queryMinLength)}</Typography>
    </CardContainer>
  )
}
